import { inject, Injectable } from "@angular/core";
import { HrmMetadataGraphQlService } from "./hrm.graphql.service";
import { map } from "rxjs";
import { CLASSIFICATION } from "app/modules/manage/workflow/task/workflow-task.constant";
import { STATUS_IN_DATABASE } from "app/shared/common/constants/Status.constant";

@Injectable({ providedIn: 'root' })
export class HrmMetadataApi {
    #grapqhQlService: HrmMetadataGraphQlService = inject(HrmMetadataGraphQlService);

    getLocalitiesByWhere(where: Object) {
        return this.#grapqhQlService.getLocalitiesByWhere(where).pipe(
            map((res) => res?.data?.map((item) => {
                delete item?.__typename
                delete item?.country?.__typename
                return item;
            }))
        )
    }

    getJobTracks(where: Object) {
        return this.#grapqhQlService.getJobTracks(where).pipe(
            map((res) => res?.data?.map((item) => {
                delete item?.__typename
                return item;
            })))
    }

    getRecruitSource() {
        return this.#grapqhQlService.queryRecruitSource();
    }

    getAllSourceTypes() {
        return this.#grapqhQlService.getAllSourceTypes();
    }

    getAttachmentTypes(where: Object) {
        return this.#grapqhQlService.getAttachmentTypes(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getJobtracks(where: Object) {
        return this.#grapqhQlService.getJobTracks(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getSkills(where: Object) {
        return this.#grapqhQlService.getSkills(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getCareerPaths(where: Object) {
        return this.#grapqhQlService.getCareerPaths(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getHrmOffice(where: Object) {
        return this.#grapqhQlService.getHrmOffice(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getJobFamilies() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } } }
        return this.#grapqhQlService.getJobs(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getJobGroups() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.GROUP } } }
        return this.#grapqhQlService.getJobs(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getJobTitles() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
        return this.#grapqhQlService.getJobTitles(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getReferralPayment() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
        return this.#grapqhQlService.getReferralPayment(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getGenders() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
        return this.#grapqhQlService.getGenders(where).pipe(
            map((v) => v?.data || [])
        )
    }

    getNationality() {
        const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
        return this.#grapqhQlService.getNationality(where).pipe(
            map((v) => v?.data || [])
        )
    }
}